export const ru =
  {
    "Try Anyplay": "Попробовать",
    "Title": "Название",
    "Author": "Автор",
    'Publisher': 'Издатель',
    'Narrator': 'Рассказчик',
    'Language': 'Язык',
    'Date': 'Дата публикации',
    'Playtime': 'Длительность',
    'Publisher description': 'Описание от издателя',
    'Join Anyplay': 'Присоединяйтесь к Anyplay!',
    'Anytime': 'В любой момент.',
    'Anywhere': 'Везде.',
    'For Anyone': 'Для каждого.',
    'We bring the best audio storytelling to every corner of the world': 'Мы приносим лучшие истории в аудио формате во все уголки мира..',
    'Sign Up': 'Регистрация',
    'Sign In': 'Войти',
    'Not found': 'Не найдено',
    'Preview': 'Превью'
  }
